import { Component, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";

import { Subject } from "rxjs";

@Component({
    selector: "evta-auth-layout",
    styleUrls: ["./auth.component.scss"],
    template: `
    <div class="auth-layout">
      <evta-auth-header></evta-auth-header>
      <div class="auth-container">
        <evta-auth-block>
          <router-outlet></router-outlet>
        </evta-auth-block>
      </div>
      <evta-auth-footer></evta-auth-footer>
    </div>
  `,
    standalone: false
})
export class AuthLayoutComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  subscription: any;

  authenticated: boolean = false;
  token: string = "";

  // showcase of how to use the onAuthenticationChange method
  constructor(protected location: Location) {}

  back() {
    this.location.back();
    return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
